<template><div>
    <h1>{{t['edit']['title']}}</h1>
    <div class="view-action-group d-flex flex-row-reverse">
        <div class="view-action-group">
            <button @click.prevent="removeAllClass" class="btn btn-outline-success" :disabled="!classes.length" >{{ t.actions.removeAll }}</button>
            <button @click.prevent="addClass" class="btn btn-outline-success">{{ t.actions.add }}</button>
        </div>
    </div>
    <div class="alert alert-warning" role="alert" v-if="!classes.length">
        {{t['is-global-information-edit']}}
    </div>
    <table class="table table-striped table-hover">
        <thead><tr>
            <th><label for="from-input">{{ t.fields.from }}</label></th>
            <th><label for="to-input">{{ t.fields.to }}</label></th>
            <th><label for="type-input">{{ t.fields.type }}</label></th>
            <th><label>{{ t.fields.color_scheme }}</label></th>
            <th/>
        </tr></thead>
        <tbody>

            <tr v-for="(c, i) in classes">
                <td><input id="from-input" type="number" :name="`class[${i}][from]`" class="form-control"
                           v-model.number="c.from" :min="classes[i - 1] ? classes[i - 1].to : 0" :max="roundToTenth(c.to - 0.1)" step="0.1"
                           required/></td>
                <td><input id="to-input" type="number" :name="`class[${i}][to]`" class="form-control"
                           v-model.number="c.to" :min="roundToTenth(c.from + 0.1)" :max="classes[i + 1] ? classes[i + 1].from : 99" step="0.1"
                           required/></td>
                <td><input id="type-input" type="text" :name="`class[${i}][type]`" class="form-control"
                           v-model="c.type" required/></td>
                <td class="align-middle" :style="{color: c.primary_color}">
                    <input type="hidden" :value="c.primary_color" id="primary_color-input" :name="`class[${i}][primary_color]`"/>
                    <fa-icon icon="circle" :id="`color-${i}`"/>
                    <b-popover :target="`color-${i}`" triggers="hover" placement="right" custom-class="fit-to-child">
                        <compact-picker :value="c.primary_color" @input="c.primary_color = $event.hex"></compact-picker>
                    </b-popover>
                </td>
                <td><button @click.prevent="() => removeClass(i)" class="btn btn-outline-danger">{{ t.actions.remove }}</button></td>
            </tr>
        </tbody>
    </table>
</div></template>

<script>
import { Slider } from 'vue-color'
import { color } from 'chart.js/helpers'
import colorscheme from '../chartjs-util/colorschemes'

const colors = colorscheme()

    export default {
        components: { 'compact-picker': Slider },
        mounted() {

        },
        props: ['t', 'errors', 'initial_classes'],
        data() {
            return {
                classes: this.initial_classes || []
            }
        },
        methods: {
            addClass() {
                const last = this.classes.slice(-1)[0]
                if (!last) {
                    this.classes.push({from: 0, to: 99, type: '', primary_color: color(colors.next().value).rgbString()})
                    return
                }

                if (last.to === 99)
                    last.to = last.from + 3
                this.classes.push({from: last.to, to: 99, type: '', primary_color: color(colors.next().value).rgbString()})
            },
            removeClass(i) {
                this.classes.splice(i, 1)
            },
            removeAllClass(i) {
                this.classes.splice(i, this.classes.length)
            },
            roundToTenth(value) {
                return Math.round(value*10)/10
            },
            onColorChanged(e) {
                console.log(e)
            }
        }
    }
</script>
